import React from 'react';
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getCoverageTypes } from '../../actions/premiumSettingsWizard'
import { stringToNumber } from '../../helpers/functions'
import { requestPatchApplicationStagedPremiumSettings } from '../../reducers/stagedPremiumsWizard'
import { CANADA_COUNTRY, COUNTRY, FLAT_PREMIUM_SETTINGS, LOADER, NONE, STAGED_PREMIUM_EDIT, STAGED_PREMIUM_SETTINGS } from '../../helpers/variables'
import { Loader } from 'arag-ui-lib'
import StagedPremiumSettingsWizardHOC from '../PremiumSettings/stagedPremiumSettingsWizardHOC'
import PremiumSettingsWizardHOC from '../PremiumSettings/premiumSettingsWizardHOC'
import ApplicationStagedPremiumSettings from '../../components/PremiumSettings/applicationStagedPremiumSettings'

const ApplicationPremiumSettingsHOC = (props) => {
  const {
    isChangingStatusOfApp,
    showTable,
    isEditMode,
    isApplicationPremium,
    applicationPremiumCancelHandler,
    selectedApplicationCaseTypeId,
    onApplicationPremiumEdit,
    applicationPremiumSaveButtonLabel,
    isEditStaged,
    onEditStaged,
    onCancel,
  } = props
  const dispatch = useDispatch()

  




  const applicationPolicy = useSelector((state) => state.applicationPolicy)
  const premiumSettingsWizard = useSelector(
    (state) => state.premiumSettingsWizard
  )
  const premiumSettings = useSelector((state) => state.premiumSettings)
  const stagedPremiumSettings = useSelector((state) => state.stagedPremiums)
  const stagedPremiumsWizard = useSelector(
    (state) => state.stagedPremiumsWizard
  )
  const stagedSubSettingsWizard = Object.values(
    useSelector((state) => state.stagedPremiumsWizard.stagesSubSettings)
  )
  const agentsList = Object.values(
    useSelector((state) => state.stagedPremiumsWizard.agentCommissionsList)
  )
  const appStagedSubSettings = Object.values(
    useSelector((state) => state.stagedPremiums.stagesSubSettings)
  )
  const applicationId = useSelector(
    (state) => state.applicationsAndPolicies.selectedApplication.id
  )

  const goingLiveLoading =
  (stagedPremiumsWizard.fetchingStagedPremium ||
    stagedPremiumsWizard.fetchingCoverageTypes ||
    stagedPremiumsWizard.fetchingStages ||
    premiumSettings.fetchingPremiumWithCombination ||
    stagedPremiumsWizard.fetching ||
    premiumSettings.fetching ||
    premiumSettings.fetchingPremiumSettingById ||
    stagedPremiumsWizard.changingApplicationStatus) &&
  !stagedPremiumsWizard.patching
  // &&  isEditStaged == true

  



  useEffect(() => {
    dispatch(getCoverageTypes())
  }, [])

  const handleStagedSubmit = () => {
    const stagesSettingsBody = stagedSubSettingsWizard.map((s) => ({
      ...s,
      underwriterRate:
        stringToNumber(stagedPremiumsWizard.underwriterRatePercentage) *
        0.01 *
        stringToNumber(s.premiumAmount),
      underwriterRatePercentage: stringToNumber(
        stagedPremiumsWizard.underwriterRatePercentage
      ),
      stagedPremiumSubSettingCommissionDtos: agentsList.map((c) => ({
        ...c,
        lawsysId: c.id,
        lawsysName: c.name,
        commission:
          stringToNumber(c.commissionPercentage) *
          0.01 *
          stringToNumber(s.premiumAmount),
        commissionPercentage: stringToNumber(c.commissionPercentage),
      })),
    }))
    const sendBody = {
      id: stagedPremiumsWizard.applicationPremiumId,
      notes: stagedPremiumsWizard.notes,
      comments: stagedPremiumsWizard.comments,
      limitOfIndemnity: 0,
      DeductibleOptionId: stagedPremiumsWizard.selectedDeductible,
      CoverageOptionId: stagedPremiumsWizard.selectedCoverageType,
      EndorsementOptionId: stagedPremiumsWizard.selectedEndorsement,
      averageExpectedPremium: stagedPremiumsWizard.averageExpectedPremium,
      applicationStagedPremiumSubSettingDtos: stagesSettingsBody,
    }
    const request = {
      sendBody,
      applicationId,
    }

    if (isApplicationPremium && isChangingStatusOfApp == true) {
      request.makeApplicationLive = true
      request.sendEmail = applicationPolicy.sendEmailNotification
    }

    dispatch(requestPatchApplicationStagedPremiumSettings(request))
  }

  const flatPremiumSettingsExist = premiumSettingsWizard.tableData.length > 0;
  const stagedPremiumSettingsExist = appStagedSubSettings.length > 0;
  const isCanadaCountry = COUNTRY === CANADA_COUNTRY;
const appPremiumSettingComponents = {
  flat :(
    <PremiumSettingsWizardHOC
      isChangingStatusOfApp={isChangingStatusOfApp}
      showTable={showTable}
      isEditMode={isEditMode}
      isApplicationPremium={isApplicationPremium}
      applicationPremiumCancelHandler={applicationPremiumCancelHandler}
      selectedApplicationCaseTypeId={selectedApplicationCaseTypeId}
      onApplicationPremiumEdit={onApplicationPremiumEdit}
      applicationPremiumSaveButtonLabel={applicationPremiumSaveButtonLabel}
    />
  ),
  staged : ( <ApplicationStagedPremiumSettings
    applicationPolicy={applicationPolicy}
    stagedPremiumSettingsWizard={stagedPremiumsWizard}
    appStagedSubSettings={appStagedSubSettings}
    stagedPremiums={stagedPremiumSettings}
    onEditStaged={onEditStaged}
    isChangingStatusOfApp={isChangingStatusOfApp}
    onCancel={onCancel}
    goingLiveLoading={goingLiveLoading}
    handleSubmit={handleStagedSubmit}
  />),
  stagedEdit:(<StagedPremiumSettingsWizardHOC
    onCancel={onCancel}
    isApplicationPremium={true}
    isEdit={true}
    handleSubmit={handleStagedSubmit} //edit application premium settings
  />),
  loader : ( <Loader variant='list' />),
  none:<></>

}
const configureOutput =
  (flatPremiumSettingsExist && !stagedPremiumSettingsExist)?
  FLAT_PREMIUM_SETTINGS :
  (stagedPremiumSettingsExist && isCanadaCountry && isApplicationPremium && !isEditStaged)?
  STAGED_PREMIUM_SETTINGS:
  (stagedPremiumSettingsExist && isCanadaCountry && isApplicationPremium && isEditStaged)?
   STAGED_PREMIUM_EDIT:
  (!flatPremiumSettingsExist && !stagedPremiumSettingsExist)?
  LOADER:
  NONE;


  return  appPremiumSettingComponents[configureOutput];
}

export default ApplicationPremiumSettingsHOC;
